import React from "react";

function About() {
  return (
    <div>
      <div className="about">
        <h1
          style={{
            color: "white",
            position: "relative",
            top: "170px",
            fontSize: "20px",
          }}
          className="about-info"
        >
          ABOUT ME
        </h1>
        <div className="book">
          <p>
            I'm a <span>Frontend Developer</span> and a publisher based in
            Nigeria,who likes to provide solution for people's projects and
            businesses which it is a challenge that I enjoy overcoming.
            <br />
            <br />I am a passionate person who pursues his dreams,works hard,and
            results oriented. I build websites with{" "}
            <span>HTML,CSS,JAVASCRIPT,</span> and some other frameworks and
            libraries.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
